// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"ConfirmationPop_ConfirmationPop__hhf2l","modalBody":"ConfirmationPop_modalBody__714sP"};